module.exports = __webpack_public_path__ + "img/user-guide-02-06-01.d0257d2b.png";